/* eslint-disable camelcase */ export var PartnerSearchResultType = /*#__PURE__*/ function(PartnerSearchResultType) {
    PartnerSearchResultType[PartnerSearchResultType["Industry"] = 0] = "Industry";
    PartnerSearchResultType[PartnerSearchResultType["Product"] = 1] = "Product";
    PartnerSearchResultType[PartnerSearchResultType["Service"] = 2] = "Service";
    PartnerSearchResultType[PartnerSearchResultType["Category"] = 3] = "Category";
    PartnerSearchResultType[PartnerSearchResultType["AdvSpec"] = 4] = "AdvSpec";
    PartnerSearchResultType[PartnerSearchResultType["Partner"] = 5] = "Partner";
    PartnerSearchResultType[PartnerSearchResultType["FreeText"] = 6] = "FreeText";
    return PartnerSearchResultType;
}({});
export const LinkedAddInsTypes = {
    outlook: true,
    onenote: true,
    officemetaos: true,
    teams: true,
    word: true,
    excel: true,
    sharepoint: true,
    viva: true,
    powerpoint: true,
    project: true
};
export var AppTag = /*#__PURE__*/ function(AppTag) {
    AppTag[AppTag["Other"] = 0] = "Other";
    AppTag[AppTag["OfficeAward"] = 1] = "OfficeAward";
    AppTag[AppTag["New"] = 2] = "New";
    AppTag[AppTag["Trending"] = 3] = "Trending";
    AppTag[AppTag["PowerBICertified"] = 4] = "PowerBICertified";
    AppTag[AppTag["AzureExpertsMSP"] = 5] = "AzureExpertsMSP";
    return AppTag;
}({});
export var MediaType = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "Image";
    MediaType["Video"] = "Video";
    return MediaType;
}({});
export var CustomerType = /*#__PURE__*/ function(CustomerType) {
    CustomerType["Organization"] = "Organization";
    CustomerType["Individual"] = "Individual";
    return CustomerType;
}({});
// Test Drive status
export var SolutionInstanceStatus = /*#__PURE__*/ function(SolutionInstanceStatus) {
    SolutionInstanceStatus["Provisioning"] = "Provisioning";
    SolutionInstanceStatus["Ready"] = "Ready";
    SolutionInstanceStatus["Deprovisioned"] = "Deprovisioned";
    SolutionInstanceStatus["Expired"] = "Expired";
    SolutionInstanceStatus["Error"] = "Error";
    SolutionInstanceStatus["Unavailable"] = "Unavailable";
    return SolutionInstanceStatus;
}({});
export var PricingStates = /*#__PURE__*/ function(PricingStates) {
    PricingStates[PricingStates["Loading"] = 1] = "Loading";
    PricingStates[PricingStates["BYOL"] = 2] = "BYOL";
    PricingStates[PricingStates["AlwaysAvailable"] = 3] = "AlwaysAvailable";
    PricingStates[PricingStates["NotAvailableInThisRegion"] = 4] = "NotAvailableInThisRegion";
    PricingStates[PricingStates["NoPricingData"] = 5] = "NoPricingData";
    PricingStates[PricingStates["FreeApp"] = 6] = "FreeApp";
    PricingStates[PricingStates["AdditionalPurchasesRequired"] = 7] = "AdditionalPurchasesRequired";
    PricingStates[PricingStates["SolutionTemplate"] = 8] = "SolutionTemplate";
    // NOTE: where is the following used?? Can it be removed?
    PricingStates[PricingStates["WebApp"] = 9] = "WebApp";
    PricingStates[PricingStates["PriceVaries"] = 10] = "PriceVaries";
    PricingStates[PricingStates["StartFromFree"] = 11] = "StartFromFree";
    PricingStates[PricingStates["LearnMore"] = 12] = "LearnMore";
    return PricingStates;
}({});
export var UserSegment = /*#__PURE__*/ function(UserSegment) {
    UserSegment[UserSegment["unauthenticated"] = 0] = "unauthenticated";
    UserSegment[UserSegment["business"] = 1] = "business";
    UserSegment[UserSegment["consumer"] = 2] = "consumer";
    UserSegment[UserSegment["edu"] = 3] = "edu";
    UserSegment[UserSegment["tenantadmin"] = 4] = "tenantadmin";
    return UserSegment;
}({});
export var CommunityItemType = /*#__PURE__*/ function(CommunityItemType) {
    CommunityItemType["Review"] = "Review";
    return CommunityItemType;
}({});
export var CheckoutSource = /*#__PURE__*/ function(CheckoutSource) {
    CheckoutSource["PdpTable"] = "PDP Table";
    CheckoutSource["PdpTop"] = "PDP Top";
    CheckoutSource["Tile"] = "Tile";
    CheckoutSource["Deeplink"] = "Deeplink";
    return CheckoutSource;
}({});
export var PricingOfferType = /*#__PURE__*/ function(PricingOfferType) {
    PricingOfferType["AppService"] = "AppService";
    PricingOfferType["VirtualMachine"] = "VirtualMachine";
    return PricingOfferType;
}({});
export var CatalogOfferType = /*#__PURE__*/ function(CatalogOfferType) {
    CatalogOfferType["None"] = "None";
    CatalogOfferType["VirtualMachine"] = "VirtualMachine";
    CatalogOfferType["AzureApplication"] = "AzureApplication";
    CatalogOfferType["Container"] = "Container";
    CatalogOfferType["SaaS"] = "SaaS";
    CatalogOfferType["ManagedServices"] = "ManagedServices";
    CatalogOfferType["DynamicsOps"] = "DynamicsOps";
    CatalogOfferType["DynamicsCE"] = "DynamicsCE";
    CatalogOfferType["DynamicsBC"] = "DynamicsBC";
    CatalogOfferType["PowerBI"] = "PowerBI";
    CatalogOfferType["ConsultingServices"] = "ConsultingServices";
    CatalogOfferType["PowerBIVisuals"] = "PowerBIVisuals";
    CatalogOfferType["Office365"] = "Office365";
    CatalogOfferType["AADApps"] = "AADApps";
    return CatalogOfferType;
}({});
export var CatalogApplicableProducts = /*#__PURE__*/ function(CatalogApplicableProducts) {
    CatalogApplicableProducts["Sales"] = "Sales";
    CatalogApplicableProducts["FieldService"] = "Field Service";
    CatalogApplicableProducts["ProjectServiceAutomation"] = "Project Service Automation";
    CatalogApplicableProducts["CustomerService"] = "Customer Service";
    CatalogApplicableProducts["CustomerVoice"] = "Customer Voice";
    CatalogApplicableProducts["Marketing"] = "Marketing";
    CatalogApplicableProducts["MixedReality"] = "Mixed Reality";
    CatalogApplicableProducts["Power_Apps"] = "Power Apps";
    CatalogApplicableProducts["PowerApps"] = "PowerApps";
    CatalogApplicableProducts["PowerAutomate"] = "Power Automate";
    CatalogApplicableProducts["PowerVirtualAgents"] = "Power Virtual Agents";
    CatalogApplicableProducts["PowerPages"] = "Power Pages";
    CatalogApplicableProducts["ProjectOperations"] = "Project Operations";
    CatalogApplicableProducts["ProjectServices"] = "Project Services";
    CatalogApplicableProducts["Commerce"] = "Commerce";
    CatalogApplicableProducts["Finance"] = "Finance";
    CatalogApplicableProducts["HumanResources"] = "Human Resources";
    CatalogApplicableProducts["SupplyChainManagement"] = "Supply Chain Management";
    CatalogApplicableProducts["BusinessCentral"] = "Business Central";
    return CatalogApplicableProducts;
}({});
export var CatalogAppFreeType = /*#__PURE__*/ function(CatalogAppFreeType) {
    CatalogAppFreeType["AppFree"] = "AppFree";
    CatalogAppFreeType["AppFreeTrial"] = "AppFreeTrial";
    CatalogAppFreeType["ExternalPurchase"] = "ExternalPurchase";
    return CatalogAppFreeType;
}({});
export var CatalogM365CertificationType = /*#__PURE__*/ function(CatalogM365CertificationType) {
    CatalogM365CertificationType[CatalogM365CertificationType["Undefined"] = 0] = "Undefined";
    CatalogM365CertificationType[CatalogM365CertificationType["None"] = 1] = "None";
    CatalogM365CertificationType[CatalogM365CertificationType["SelfAttested"] = 2] = "SelfAttested";
    CatalogM365CertificationType[CatalogM365CertificationType["MicrosoftCertified"] = 3] = "MicrosoftCertified";
    return CatalogM365CertificationType;
}({});
export var CatalogPricingTypes = /*#__PURE__*/ function(CatalogPricingTypes) {
    CatalogPricingTypes["Payg"] = "Payg";
    CatalogPricingTypes["Free"] = "Free";
    CatalogPricingTypes["FreeTrial"] = "FreeTrial";
    CatalogPricingTypes["Byol"] = "Byol";
    return CatalogPricingTypes;
}({});
export var OrchestrationType = /*#__PURE__*/ function(OrchestrationType) {
    OrchestrationType["PowerBi"] = "PowerBi";
    OrchestrationType["LabManager"] = "LabManager";
    OrchestrationType["LogicApp"] = "LogicApp";
    return OrchestrationType;
}({});
export var PricingAudience = /*#__PURE__*/ function(PricingAudience) {
    PricingAudience["DirectCommercial"] = "DirectCommercial";
    PricingAudience["PartnerCommercial"] = "PartnerCommercial";
    return PricingAudience;
}({});
export var IAvailabilityActions = /*#__PURE__*/ function(IAvailabilityActions) {
    IAvailabilityActions["Browse"] = "Browse";
    IAvailabilityActions["Curate"] = "Curate";
    IAvailabilityActions["Consume"] = "Consume";
    IAvailabilityActions["Details"] = "Details";
    IAvailabilityActions["Purchase"] = "Purchase";
    IAvailabilityActions["Renew"] = "Renew";
    return IAvailabilityActions;
}({});
export var TermsStrings = /*#__PURE__*/ function(TermsStrings) {
    TermsStrings["Term30DString"] = "P30D";
    TermsStrings["Term90DString"] = "P90D";
    TermsStrings["Term1HString"] = "P1H";
    TermsStrings["Term1MString"] = "P1M";
    TermsStrings["Term3MString"] = "P3M";
    TermsStrings["Term1YString"] = "P1Y";
    TermsStrings["Term2YString"] = "P2Y";
    TermsStrings["Term3YString"] = "P3Y";
    TermsStrings["HourString"] = "HR";
    TermsStrings["MonthString"] = "Month";
    TermsStrings["YearString"] = "Year";
    TermsStrings["FreeTrial"] = "FreeTrial";
    TermsStrings["OneTime"] = "OneTime";
    return TermsStrings;
}({});
export var Badges = /*#__PURE__*/ function(Badges) {
    Badges["MAICPPCertifiedSolution"] = "MAICPPCertifiedSolution";
    Badges["CopilotExtension"] = "CopilotExtension";
    return Badges;
}({});
export var OdataRawObjectAppType = /*#__PURE__*/ function(OdataRawObjectAppType) {
    OdataRawObjectAppType[OdataRawObjectAppType["public"] = 0] = "public";
    OdataRawObjectAppType[OdataRawObjectAppType["private"] = 1] = "private";
    return OdataRawObjectAppType;
}({});
export var PlansEntityOS = /*#__PURE__*/ function(PlansEntityOS) {
    PlansEntityOS["windows"] = "windows";
    PlansEntityOS["linux"] = "linux";
    return PlansEntityOS;
}({});
export var DakotaOfferType = /*#__PURE__*/ function(DakotaOfferType) {
    DakotaOfferType["AzureApplication"] = "AzureApplication";
    DakotaOfferType["Container"] = "Container";
    DakotaOfferType["ContainerApp"] = "ContainerApp";
    DakotaOfferType["DevService"] = "DevService";
    DakotaOfferType["IoTEdgeModule"] = "IoTEdgeModule";
    DakotaOfferType["ManagedApp"] = "ManagedApp";
    DakotaOfferType["ManagedServices"] = "ManagedServices";
    DakotaOfferType["SaaSApp"] = "SaaSApp";
    DakotaOfferType["SolutionTemplate"] = "SolutionTemplate";
    DakotaOfferType["VirtualMachine"] = "VirtualMachine";
    DakotaOfferType["PowerBI"] = "PowerBI";
    DakotaOfferType["PowerBIVisuals"] = "PowerBIVisuals";
    DakotaOfferType["DynamicsCE"] = "DynamicsCE";
    DakotaOfferType["None"] = "None";
    DakotaOfferType["DynamicsOps"] = "DynamicsOps";
    DakotaOfferType["DynamicsBC"] = "DynamicsBC";
    DakotaOfferType["ConsultingServices"] = "ConsultingServices";
    DakotaOfferType["Office365"] = "Office365";
    DakotaOfferType["AAD"] = "AAD";
    return DakotaOfferType;
}({});
export var ISearchFilterCategory = /*#__PURE__*/ function(ISearchFilterCategory) {
    ISearchFilterCategory["Products"] = "Products";
    return ISearchFilterCategory;
}({});
export const ratingValues = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
